export const waitForImages = async (container: HTMLElement): Promise<void> => {
	const images = Array.from(container.querySelectorAll("img"));

	const promises = images.map(img => {
		if (img.complete) return Promise.resolve();
		if (img.loading === "lazy" && img.offsetParent === null) return Promise.resolve();
		return new Promise(resolve => {
			img.onload = resolve;
			img.onerror = resolve;
		});
	});

	await Promise.all(promises);
}
